var map = {
	"./gargoyle_geiz.png": "d6ce",
	"./gargoyle_hochmut.png": "1528",
	"./gargoyle_voellerei.png": "5dbb",
	"./gargoyle_wollust.png": "dbd5",
	"./gargoyle_zorn.png": "6232",
	"./geiz.png": "4339",
	"./hochmut.png": "16c4",
	"./neid.png": "0c10",
	"./traegheit.png": "e0c2",
	"./voellerei.png": "1a74",
	"./wollust.png": "dcf9",
	"./zorn.png": "2d9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";